// Tag Closuure Details --Reasons
import React from "react";
import { View, TextInput, } from "react-native";
import CText from "../../common/CText";
import CView from "../../common/CView";
import RadioButton from "../../common/RadioButton";
import useStyles from "./TagClosure_Styles";
import { CLOSE_TAG_REASONS } from "../../constant/dataHelper";
import CPanDetails from "../../common/CPanDetails";

export default function DetailsWidget(props) {
    const styles = useStyles();
    const finalRefundAmount = props?.finalRefundAmount || 0
    const closeTagType = props?.closeTagType
    const otherText = props?.otherText
    const vehicleLength = props?.vehicleLength
    const aadharConfrimTag = props?.aadharConfrimTag
    const userData = props?.userData
    const isInitiateVeriyApiSuccess = props?.isInitiateVeriyApiSuccess
    const enableManualDoc = props?.enableManualDoc
    const panSubmit  = props?.panSubmit

    const onProceed = (req)=>{
      props?.validatePan(req)
      // props.setAadharConfirmationModal(true)
      // setJourneyId(req?.journeyId)
    }

    return(
              <CView W100>
                <CView MT={15} W100>
                  <CView FR style={{ width: '100%', marginTop: 12, alignItems: 'center' }}>
                    <CText.headerText>{"Reason for closing Tag"}</CText.headerText>
                    <View style={{ height: 1, backgroundColor: '#dedede', flex: 1, marginLeft: 5 }}></View>
                  </CView>
                  <CView FR style={styles.fullWidth}>
                    <CView style={styles.contentSpace}>
                      <RadioButton
                        PROP={CLOSE_TAG_REASONS}
                        orientation={"column"}
                        dir={"column"}
                        onSelect={(value) =>  props?.setCloseTagType(value.key)}
                        selectedValue={closeTagType}
                        redBg={true}
                      />
                    </CView>
                    <CView style={styles.contentSpace}>
                      { closeTagType == "Others" && (
                          <TextInput
                            multiline={true}
                            style={styles.otherTextarea}
                            placeholder="comment"
                            value={otherText}
                            onChangeText={e => props?.setOtherText(e)}
                            maxLength={225}
                          />
                        )}
                    </CView>
                  </CView>
                </CView>
                {vehicleLength > 1 || aadharConfrimTag == "No" || userData?.kyc == "EKYC" ? null :
                  <CView style={{ width: '100%', display: isInitiateVeriyApiSuccess ? 'none' : 'flex' }}>
                    <CView FR style={{ width: '100%', marginTop: 12, marginBottom: 8, alignItems: 'center' }}>
                      <CText.headerText>{"PAN Verification"}</CText.headerText>
                      <View style={{ height: 1, backgroundColor: '#dedede', flex: 1, marginLeft: 5 }}></View>
                    </CView>
                    <CView  style={styles.fullWidth}>
                      <CPanDetails type = {"tagClousure"} onSubmit= {onProceed}/>
                    </CView>

                  </CView>
                }
                {(vehicleLength == 1 && aadharConfrimTag == "No")  || enableManualDoc  ?
                   vehicleLength === 1 || panSubmit || userData?.kyc != "EKYC" ?
                   props?.RenderDetails("documentDetails")
                    :null
               : null}
               {console.log(finalRefundAmount,'finalRefundAmount33')}
                { finalRefundAmount && finalRefundAmount >= 1000 ? 
                 props?.RenderDetails("cancelCheque")
                :null}
               
                { (vehicleLength == 1 && aadharConfrimTag == "No") || (vehicleLength == 1 && userData?.kyc == "EKYC") || isInitiateVeriyApiSuccess || enableManualDoc ?
                     props?.RenderDetails("details")
                    : null}

              </CView>
                 
    )
}

